@import '../../css/typography-helpers';

// Code editor styles

.cm-editor {
  background-color: white;
}

.cm-scroller,
.cm-gutters {
  min-height: 150px !important;
}
